import { defaultHttpClient } from '../../httpClient';

export const postRedeemAllMarketCoupon = (marketId: number) => {
  return defaultHttpClient
    .request({
      url: `/api/v2/markets/${marketId}/coupons/redeem/`,
      method: 'POST',
    })
    .then(result => result.data);
};
